import React from "react";
import FaqItem from "../FaqItem";

function FAQs() {
  return (
    <div className="mt-10">
      <FaqItem
        question="How do I find my chauffeur"
        answer="Your chauffeur will await you at the arrival hall of the airport. You can easily locate him by spotting a personalized pickup sign which will be held by him."
      />

      <FaqItem
        question="How will he know I am the right passenger"
        answer="He will ask for your Booking Ref Number and trip details, which you are expected to provide"
      />

      <FaqItem
        question="If he arrives earlier, do I get charged for additional wait time"
        answer="Shuttlelane does not charge clients for additional wait time when the wait time hasn't been exceeded. The complimentary wait time for airport pickups is 1 hour and 20 minutes for other cases. Once you have given us your flight details during booking, tracking your arrival time and adjusting your pickup time becomes an easy thing to do."
      />

      <FaqItem
        question="How do I make a booking"
        answer="Bookings can be made through our official website: www.shuttlelane.com or via our mobile application."
      />

      <FaqItem
        question="How do I get back what I forgot in your car"
        answer="If you misplace or forget any item in any of our vehicles, just send us an email, describing the item in question. Just make sure to give us your contact details as well. Once you get in contact with us, you will be replied to accordingly."
      />

      <FaqItem
        question="What are the vehicle types and how many passengers can they carry"
        answer="We have a large variety of cars at Shuttlelane. You can get information about them and their carrying capacities on our FLEET page. If you have any special requirement, do well to communicate it to us."
      />

      <FaqItem
        question="Can I book on behalf of a third party"
        answer="You are allowed to book with us on behalf of a third party. Just be sure to fill in the contact details and the mobile number of such third party so that the Chauffeur can get in touch at the time of pick-up if necessary"
      />

      <FaqItem
        question="Can I take animals on my journey"
        answer="As much awesome as pets are, we do not carry them. Sorry about that."
      />

      <FaqItem
        question="What happens after I make a booking"
        answer="Once you have booked with us, we send an email and a text message for confirmation. Make sure you go through the confirmation mail to ascertain the correctness of your journey details."
      />

      <FaqItem
        question="Are prices shown per person or vehicle"
        answer="Our prices at Shuttlelane are often listed per vehicle. The price will cover all taxes, gratuities as well as fees. You can check for the maximum number of passengers and Luggage that a car can covey under each car class. Bear in mind however that the number of passengers doesn't affect the price."
      />

      <FaqItem
        question="What is Shuttlelane cancellation policy"
        answer="In case of transfer/one-way bookings, you can cancel the arrangement for free provided we have more than 24 hour before the agreed pickup time. But, the total price must be paid when time left is 4hour or below to the agreed pick-up time."
      />

      <FaqItem
        question="What can I do if I can't locate my chauffeur"
        answer="Give our office a call ASAP and try not to leave the arrival hall as we try to find him."
      />

      <FaqItem
        question="Does Shuttlelane cater for weddings"
        answer="Yes, we cater for weddings. We have exotic cars suitable for wedding ceremonies. You can also get additional vehicles for your guests if you so wish."
      />

      <FaqItem
        question="How do I verify the status of my Nigerian Visa On Arrival"
        answer="You can verify your Nigeria visa on arrival status online from anywhere, visit the Nigeria Immigration portal;  Go to Visa on Arrival Program under Application, then enter your Application ID and Reference Number as seen in the visa approval letter received."
      />

      <FaqItem
        question="Can I get a Nigerian Visa On Arrival (at the airport)"
        answer="Yes, getting a Nigeria visa on arrival is possible. However, you need to get a letter of approval before traveling to Nigeria to get your Visa on Arrival at the airport."
      />

      <FaqItem
        question="Is there any extra charge on arrival at the airport in Nigeria"
        answer="NO! There are no extra or hidden charges. All fees are paid upfront before a letter of approval can be obtained."
      />

      <FaqItem
        question="What documents do you require to process my Visa On Arrival"
        answer="NO! There are no extra or hidden charges. All fees are paid We require that you provide a copy of your passport data page, a passport photo and a Round Trip Ticket."
      />

      <FaqItem
        question="Can I travel without the letter of approval"
        answer="No, you can’t. Before you travel to Nigeria, you must obtain a pre-approved visa or letter of approval; otherwise, immigration will send you back from the airport."
      />

      <FaqItem
        question="What is the duration of the Nigerian Visa On Arrival"
        answer="The Nigerian Visa on Arrival (VoA) is valid for a period of 30 days, with a single entry. Though it can be extended for a maximum of 6 months after entry."
      />

      <FaqItem
        question="Who is eligible to apply for a Nigerian Visa On Arrival"
        answer="Anyone who requires a visa to enter Nigeria can apply for Visa on Arrival."
      />

      <FaqItem
        question="How long does it take to get a Nigerian Visa On Arrival approval letter"
        answer="Normally, it takes one business day to get an approval letter for a Nigerian Visa on Arrival. What we guarantee is that your application through Shuttlelane will be the fastest and most guaranteed way to get a Nigeria visa on arrival."
      />

      <FaqItem
        question="What if my question is not covered here"
        answer="You can forward any question not covered here to our email. We promise to give you a swift and favourable response."
      />
    </div>
  );
}

export default FAQs;
